import { createElement } from 'react'

const keyDownA11y = (handler) => {
  return function onKeyDown(event: React.KeyboardEvent) {
    if (['keydown', 'keypress'].includes(event.type) && ['Enter', ' '].includes(event.key)) {
      handler()
    }
  }
}

export default function A11yButton({ elementType = 'div', onClick, ...props }) {
  return createElement(elementType, {
    ...props,
    onClick,
    onKeyDown: keyDownA11y(onClick),
    role: 'button',
  })
}
